/* import __COLOCATED_TEMPLATE__ from './radio-button-input.hbs'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { once } from '@ember/runloop';
import { action } from '@ember/object';
let RadioButtonInputComponent = (_class = class RadioButtonInputComponent extends Component {
  get checkedStr() {
    const checked = this.args.checked;
    if (typeof checked === 'boolean') {
      return checked.toString();
    }
    return null;
  }
  change() {
    if (this.args.groupValue !== this.args.value) {
      // this.set('groupValue', value);
      once(this.args, 'changed', this.args.value);
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "change", [action], Object.getOwnPropertyDescriptor(_class.prototype, "change"), _class.prototype), _class);
export { RadioButtonInputComponent as default };